import { Image, Container, Row, Col, Card } from 'react-bootstrap';
import "./Services.css";
import Img from '../Img/Contact/Contact Banner.jpg';
import Phone from '../Img/Contact Icons/call.png';
import Mail from '../Img/Contact Icons/mail.png';
import Map from '../Img/Contact Icons/map.png';
import Whatsapp from '../Img/Contact Icons/whatsapp.png';

function Contact() {
  return (
    <>
      <Image className="fade-in responsive-img" src={Img} height={500} width="100%" fluid />

      <Container>
        <div>
          <h1 className='text-center my-4 text-decoration-underline'><strong>Contact Us</strong></h1>
          <p className="fs-5 justify-text mb-0"><strong>Have a shipment to move? Looking for a reliable logistics partner? We’re here to help.</strong></p>
              <p className="fs-5 justify-text mb-0"><strong>At DELTRANS GLOBAL, we understand that every shipment matters. Whether you need import, export, customs clearance, or complete freight management solutions, our experienced team is ready to provide fast, secure, and cost-effective services tailored to your needs.</strong></p>
              <p className="fs-5 justify-text mb-0"><strong>No matter the size or destination of your cargo, we are committed to delivering efficiency, transparency, and peace of mind at every step.</strong></p>

          <Row className="g-4 m-5">
            <Col xs={12} md={6} className='my-3 py-2'>
              {/* <h2 className='py-4'><u>Get in Touch</u></h2> */}
              <p className="fs-4 justify-text mb-0" style={{ textIndent: "-3rem" }}> <strong>📦 Let us simplify your logistics.</strong></p>
              <p className="fs-4 justify-text mb-0" style={{ textIndent: "-3rem" }}> <strong>📞 Reach out today for a quick consultation or freight quote.</strong> </p>
              <p className="fs-4 justify-text mb-0" style={{ textIndent: "-3rem" }}> <strong>✉️ Our team will respond promptly and guide you through the next steps.</strong> </p>
              
              <p className="fs-4 fs-md-5 py-3 mb-0" style={{ textIndent: "-3rem" }}>
                <img className='mx-2' src={Phone} alt="Phone Logo" width={30} height={30} />
                <strong>Mobile No-</strong>
                <a href="tel:+971503713027" className="contact-link mx-2">
                  +971-50-371-3027
                </a></p>
              <p className="fs-4 fs-md-5 py-3 mb-0" style={{ textIndent: "-3rem" }}>
                <img className='mx-2' src={Whatsapp} alt="Phone Logo" width={30} height={30} />
                <strong>WhatsApp-</strong>
                <a
                  href="https://wa.me/+971503713027?"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Chat with us on WhatsApp"
                  className="contact-link mx-2 ps-2"
                >
                  +971-50-371-3027
                </a>
              </p>

              <p className="fs-4 fs-md-5 py-3 mb-0" style={{ textIndent: "-3rem" }}>
                <img className='mx-2' src={Mail} alt="Phone Logo" width={30} height={30} />
                <strong>Email-</strong>
                <a href="mailto:uae@deltransglobal.com" className="contact-link mx-2 ps-5">
                  uae@deltransglobal.com
                </a></p>

              <p className="fs-4 fs-md-5 pt-3 mb-0" style={{ textIndent: "-3rem" }}>
                <img className='mx-2' src={Map} alt="Phone Logo" width={30} height={30} />
                <strong>Address-</strong> <span className='ps-2'>Business Centre,</span>
              </p>
              <p className="fs-4 fs-md-5" style={{ paddingLeft: "8rem" }}>
                Sharjah Publishing City Free Zone, Sharjah, U.A.E.
              </p>

            </Col>
            <Col xs={12} md={6} className='my-3 py-2'>
              <Card className='my-2' style={{ border: '2px solid rgb(5, 6, 8)' }}>
                <Card.Body>
                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3606.532421821164!2d55.4585985!3d25.3199091!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5f26195b7e6b%3A0xc0f6d4eb509bdf75!2sSPC%20Free%20Zone%20-%20Business%20Setup%20In%20Sharjah%2C%20UAE!5e0!3m2!1sen!2sin!4v1770809932506!5m2!1sen!2sin"
                    style={{ width: "100%", height: 500 }}
                    title='Map' ></iframe>
                </Card.Body>
              </Card>

            </Col>
          </Row>
        </div>
      </Container>
    </>
  )
}

export default Contact